import classes from './change-kilometer-form.module.scss';
import { FormFieldTypes } from 'common/enums';
import { FormFieldModel } from 'common/interfaces';
import { ChangeKilometerFormFieldValues } from './change-kilometer-form.props';
import { errorMessages } from 'utils/error-messages';
import { regexValue } from 'utils/regex';
import moment from 'moment';

export const getChangeKilometerForm = (isRow: boolean): FormFieldModel<keyof ChangeKilometerFormFieldValues>[] => [
  {
    name: 'uds_mileage',
    label: isRow ? 'Km-Stand' : '',
    placeholder: 'XXX.XXX km',
    type: FormFieldTypes.Number,
    containerClassName: classes.form_field,
    validation: {
      required: errorMessages.number,
      min: { value: 2, message: errorMessages.getMinNumberValue(1) },
      maxLength: { value: 9, message: errorMessages.getMaxNumberLength(9) },
      pattern: { value: regexValue.onlyInteger, message: errorMessages.number }
    }
  },
  {
    name: 'uds_date_of_mileage',
    label: 'Datum des Km-Standes',
    type: FormFieldTypes.Date,
    maxDate: moment(),
    defaultValue: null,
    containerClassName: classes.form_field,
    validation: {
      required: errorMessages.required
    }
  }
];
